import * as Types from '../../../generated/webapp_gql';

import { PathwayFragment, PathwayAssessmentFragment, PathwayAssessmentQuestionFragment, MemberPathwayFragment, PathwayProviderFragment, PathwayTopicFragment, PathwayTopicGoalFragment, PathwaySessionFragment, PathwayCoachingVisitFragment, RecommendedActivities_AssessmentLinkNode_Fragment, RecommendedActivities_CircleSeriesLinkNode_Fragment, RecommendedActivities_CircleSessionLinkNode_Fragment, RecommendedActivities_CircleTopicLinkNode_Fragment, RecommendedActivities_CourseLinkNode_Fragment, RecommendedActivities_ExternalLinkNode_Fragment, RecommendedActivities_HrEventLinkNode_Fragment, RecommendedActivities_HrResourceLinkNode_Fragment, RecommendedActivities_InternalLinkNode_Fragment, RecommendedActivities_MeditationLinkNode_Fragment, RecommendedActivities_ProgramLinkNode_Fragment, RecommendedActivities_ScreenLinkNode_Fragment, PathwayAssessmentActivityFragment, CareActionsFragment } from './fragments.generated';
import { gql } from 'graphql.macro';
import { PathwayFragmentDoc, PathwayAssessmentFragmentDoc, PathwayAssessmentQuestionFragmentDoc, MemberPathwayFragmentDoc, PathwayProviderFragmentDoc, PathwayTopicFragmentDoc, PathwayTopicGoalFragmentDoc, PathwaySessionFragmentDoc, PathwayCoachingVisitFragmentDoc, RecommendedActivitiesFragmentDoc, PathwayAssessmentActivityFragmentDoc, CareActionsFragmentDoc } from './fragments.generated';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
const defaultOptions =  {}
export type PathwaysQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PathwaysQuery = (
  { __typename?: 'Query' }
  & { pathways?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'PathwayNode' }
    & PathwayFragment
  )>>> }
);


export const PathwaysDocument = gql`
    query pathways {
  pathways(platform: WEB) {
    ...pathway
  }
}
    ${PathwayFragmentDoc}
${PathwayAssessmentFragmentDoc}
${PathwayAssessmentQuestionFragmentDoc}
${MemberPathwayFragmentDoc}
${PathwayProviderFragmentDoc}
${PathwayTopicFragmentDoc}
${PathwayTopicGoalFragmentDoc}
${PathwaySessionFragmentDoc}
${PathwayCoachingVisitFragmentDoc}
${RecommendedActivitiesFragmentDoc}
${PathwayAssessmentActivityFragmentDoc}
${CareActionsFragmentDoc}`;

/**
 * __usePathwaysQuery__
 *
 * To run a query within a React component, call `usePathwaysQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathwaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathwaysQuery({
 *   variables: {
 *   },
 * });
 */
export function usePathwaysQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PathwaysQuery, PathwaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PathwaysQuery, PathwaysQueryVariables>(PathwaysDocument, options);
      }
export function usePathwaysLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PathwaysQuery, PathwaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PathwaysQuery, PathwaysQueryVariables>(PathwaysDocument, options);
        }
export type PathwaysQueryHookResult = ReturnType<typeof usePathwaysQuery>;
export type PathwaysLazyQueryHookResult = ReturnType<typeof usePathwaysLazyQuery>;
export type PathwaysQueryResult = ApolloReactCommon.QueryResult<PathwaysQuery, PathwaysQueryVariables>;